import React from "react";
import "./newlaunching.scss";
import imgnl from "../../../../assets/home/flyervicente.png";
import {
  faBed,
  faHouse,
  faMaximize,
  faShower,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";

const newlaunching = () => {
  const waabout = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send?phone=62895417144022&text=Halo%20Sandy,%20Saya%C2%A0bisa%20minta%20detail%20Katalog,%20Simulasi%20dan%20Promo%20terbaru%20rumah%20ini%20()%20(https://marketing-grandwisatabekasi.com/)%20?&fbclid=PAAaa7g9IJ-tB3RyMunLD6w_5ysqP4oI6PA2d9Ml7Isc1_OXjeOiGuAqu7Ap0";
    window.location.href = whatsappLink;
  };
  return (
    <div className="newlaunching">
      <div className="container-newlaunching">
        <div className="container-imagenl">
          <img src={imgnl} alt="flyernl" />
        </div>
        <div className="container-content">
          <div className="headernl">Vicente at Klasika</div>
          <div className="desknl">
            Tanpa DP & Free Biaya KPR, Cicilan Mulai 7 Juta/Bulan
          </div>
          <div className="card-icon">
            <FontAwesomeIcon icon={faMaximize} />
            <span>: 140m² </span>
            <FontAwesomeIcon icon={faHouse} />
            <span>: 154m² </span>
            <FontAwesomeIcon icon={faBed} />
            <span>: 4+1 </span>
            <FontAwesomeIcon icon={faShower} />
            <span>: 4+1 </span>
          </div>
          <div className="button">
            <button onClick={waabout} className="whatsapp">
              <FontAwesomeIcon icon={faWhatsapp} /> Hubungi Kami
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default newlaunching;
